import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import { routes as broadbandRoutes } from './broadband/BroadbandRoutes'
import { config } from './config/config'
import { useGetWhiteLabelColorQuery } from './broadband/white-labeling.api'
import { GlobalStyle } from './global-styles'
import { routes as mobileRoutes } from './mobile/MobileRoutes'
import Layout from './shared/components/Layout'
import { withTheme } from 'styled-components'
import { LoaderContainer } from './shared/components/LoaderContainer'

const { analytics } = config
const { gaTrackingId } = analytics

if (process.env.NODE_ENV !== 'production') {
  const axe = require('@axe-core/react')
  axe(React, ReactDOM, 1000)
}

const App = () => {
  const queryParameters = new URLSearchParams(window.location.search)
  const whiteLabelClientId = queryParameters.get('utm_source')
  const updateTheme = color => {
    if (color) {
      document.documentElement.style.setProperty('--primary500-color', color)
    }
  }
  ReactGA.initialize(gaTrackingId)
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  const location = useLocation()

  const isMobileSafari = () => {
    const isIos = /iP(ad|od|hone)/i.test(window.navigator.userAgent)
    const isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/)
    return isIos && isSafari
  }

  const getTypeFromPath = () => {
    const path = location.pathname
    if (path.startsWith('/mobile')) return 'mobile'
    if (path.startsWith('/broadband')) return 'broadband'
    return 'broadband' // default to broadband if no match
  }

  const { data: whiteLabelColor, isLoading } = useGetWhiteLabelColorQuery(
    {
      clientId: whiteLabelClientId,
      type: getTypeFromPath()
    },
    {
      skip: !whiteLabelClientId
    }
  )

  useEffect(() => {
    if (whiteLabelColor?.styleConfig) {
      updateTheme(whiteLabelColor.styleConfig)
    }
  }, [whiteLabelColor])

  useEffect(() => {
    if (isMobileSafari()) {
      document.documentElement.style.setProperty(
        '--height',
        `${window.innerHeight}px`
      )
    }
    window.scrollTo(0, 0)
  }, [location.pathname])

  useEffect(() => {
    const listener = e => {
      document.activeElement.blur()
    }
    document.addEventListener('touchmove', listener)
    return () => document.removeEventListener('touchmove', listener)
  }, [])

  const verticals = [broadbandRoutes, mobileRoutes]

  const routes = _.flattenDeep(verticals)

  return (
    <>
      {whiteLabelClientId && <LoaderContainer isLoading={isLoading} />}
      <div className="main-container">
        <Layout>
          <Switch>
            <Route exact path="/">
              <Redirect to={routes[0].path} />
            </Route>
            {routes.map((route, i) => (
              <Route
                exact
                key={i}
                path={route.path}
                render={props => (
                  <route.component {...props} config={route.config || {}} />
                )}
              />
            ))}
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </Layout>
        <GlobalStyle />
      </div>
    </>
  )
}

export default withTheme(App)
